const { getAlgoliaResults } = window["@algolia/autocomplete-js"];
const locale = window?.Shopify?.locale ?? 'en';

// github.com/nilsabdi - feel free to shoot me an email for an explanation.
// This is an extremely hacky solution; we shouldn't be mangling the app - but rather implement our own autocomplete.

const productsPlugin = {
  
  getSources({ query }) {
    if (!query) {
          return [
            {
              sourceId: "products",
              getItems({ query }) {
                return window.agCollections;
              },
              getItemUrl({ item }) {
                return `/collections/${item.handle}/`;
              },
              onSelect({ item }) {
                window.location.href = `/collections/${item.handle}/`;
              },
              templates: {
                header({ _, html}) {
                  return html`<div class="aa-SourceHeader sacred"><span class="aa-SourceHeaderTitle">${locale == 'en' ? 'Popular collections' : 'Populære kollektioner'}</span><div class="aa-SourceHeaderLine"></div></div>`;
                },
                item({ item, html }) {
                  return html`
                    <a
                      href="/collections/${item.handle}/"
                      class="aa-ItemLink aa-ProductItem"
                    >
                      <div class="aa-ItemContent">
                        <div class="aa-ItemPicture aa-ItemPicture--loaded">
                          <img
                            style="height: 100%; width: 100%; object-fit: cover; object-position: center;"
                            src="${item.image.src}"
                            alt="${item.title}"
                          />
                        </div>
                        <div class="aa-ItemContentBody">
                          <!--<div class="aa-ItemContentBrand">
                            Poster<span> by </span>Karolina
                            <mark>S</mark>zékely
                          </div>-->
                          <div class="aa-ItemContentTitleWrapper">
                            <div class="aa-ItemContentTitle text"
                              style="text-align: center;"
                            >
                              ${item.title}
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  `;
                },
              },
            },
          ];

      // return fetch("https://ZHSV2Y9AJA-dsn.algolia.net/1/indexes/shopify_collections", {
      //   headers: {
      //     "X-Algolia-API-Key": "d7d777880ef17ff20c17ada970645d47",
      //     "X-Algolia-Application-Id": "ZHSV2Y9AJA",
      //   }}).then((response) => response.json())
      //   .then((data) => {
      //     let collections = data.hits;
      //     let usedCollections = [];
      //     console.log({ data });
      // });
    
    }
    if (query) {
      return [
        {
          sourceId: "products",
          getItems({ query }) {
            return getAlgoliaResults({
              searchClient: algoliaShopify.searchClient,
              queries: [
                {
                  indexName: "shopify_products",
                  query,
                  distinct: algoliaShopify.config.show_products
                },
              ],
            });
          },
          getItemUrl({ item }) {
            // console.log({ internalType: "product", item });
            return item.url;
          },
          // onSelect({ item }) {
          //   window.location.href = `/products/${item.handle}/`;
          // },
          templates: {
            header({ html, state}) {
              return html`<div class="aa-SourceHeader sacred"><span class="aa-SourceHeaderTitle">${locale == 'en' ? 'Products' : 'Produkter'} ${state.query ? 'for ' + state.query : ''}</span><div class="aa-SourceHeaderLine"></div></div>`;
            },
            item({ components, item, html }) {

              const a = algoliaShopify.config.show_products || item.objectID === item.id ? "" : `?variant=${item.objectID}`;

              item = algoliaShopify.helpers.localizeHitData(item);
              // console.log({
              //   components,
              //   item,
              //   html,
              // })
              // item({item: t, html: n, components: o}) {
              //   const i = r.show_products
              //     , a = i || t.objectID === t.id ? "" : `?variant=${t.objectID}`;
              //   return ((e,t,r,n,o)=>{
              //       e.item = o.helpers.localizeHitData(e.item);
              //       const {html: i, components: a, item: u} = e
              //         , c = i`


              return html`
                    <a
                      href="/products/${item.handle}/${a}"
                      class="aa-ItemLink aa-ProductItem"
                    >
                      <div class="aa-ItemContent">
                        <div class="aa-ItemPicture aa-ItemPicture--loaded">
                          <img
                            style="height: 100%; width: 100%; object-fit: contain; object-position: center;"
                            src="${algoliaShopify.helpers.compactImage(item)}"
                            alt="${item.title}"
                          />
                        </div>
                        <div class="aa-ItemContentBody">
                          <div class="aa-ItemContentBrand"
                            style="text-align: center;"
                          >
                          ${item.product_type && components.Highlight({
                            hit: item,
                            attribute: "product_type"
                                              })}
                          ${locale == 'en' && item.vendor && html`
                              <span> by </span>
                            `}
                            ${locale == 'da' && item.vendor && html`
                              <span> af </span>
                            `}
                          ${item.vendor && components.Highlight({
                                                  hit: item,
                                                  attribute: "vendor"
                                              })}
                          </div>
                          <div class="aa-ItemContentTitleWrapper">
                            <div class="aa-ItemContentTitle text"
                              style="text-align: center;"
                            >
                            ${components.Highlight({
                              hit: item,
                              attribute: "title"
                          })}
                            </div>
                          </div>
                          <div class="aa-ItemContentPrice" style="justify-content: center;">
                            <div class="aa-ItemContentPriceCurrent">
                              ${algoliaShopify.helpers.displayPrice(item)}
                              <!-- ${algoliaShopify.helpers.displayPrice(item)} -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  `;
            },
          },
        },
      ];
    }


  },
};

(function () {
  setInterval(() => {
    if (window.algoliaShopify) {
      // This would get me fired from an actual job. 
      document.querySelector(".aa-PanelSection--left > .aa-SourceHeader").remove();
    }
  }, 50);
  document.addEventListener("algolia.hooks.initialize", function () {
    // Option params https://www.algolia.com/doc/ui-libraries/autocomplete/api-reference/autocomplete-js/autocomplete/#parameters
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteOptions",
      function (options) {
        // options.debug = true;
        options.openOnFocus = true; // https://www.algolia.com/doc/ui-libraries/autocomplete/api-reference/autocomplete-js/autocomplete/#param-openonfocus

        // Use reshape to override the source header funcs
        options.reshape = ({ sourcesBySourceId }) => {
          const {
            collections,
            querySuggestionsPlugin,
            ...rest
          } = sourcesBySourceId;
          
          collections.templates.header = ({ _, html}) => {
            return html`<div class="aa-SourceHeader sacred"><span class="aa-SourceHeaderTitle">${locale == 'en' ? 'Collections' : 'Kollektioner'}</span><div class="aa-SourceHeaderLine"></div></div>`;
          };

          querySuggestionsPlugin.templates.header = ({ _, html}) => {
            return html`<div class="aa-SourceHeader sacred"><span class="aa-SourceHeaderTitle">${locale == 'en' ? 'Suggestions' : 'Forslag'}</span><div class="aa-SourceHeaderLine"></div></div>`;
          };
      
          return [
            collections,
            querySuggestionsPlugin,
            Object.values(rest),
          ];
        };      
        options.onStateChange = function ({ state }) {
          // console.log({ state });
        };
        
        // Slice out the exisiting productPlugin, so we can recreate it with the new getSources
        const plugins  = options.plugins.slice(1) || [];

        options.plugins = [...plugins, productsPlugin];
          
        return options;
      }
    );
  });
})();
